import { Camera, SearchCheck, Truck } from "lucide-react";
import Reveal from "./Reveal";

const CHAPTERS = [
  {
    num: "01", icon: Camera, title: "SNAP & IDENTIFY",
    text: "Find your unit's data plate — electric storage: sticker around the top of the cylinder. Gas storage: plate low on the opposite side of the panel. Continuous flow: sticker on the side of the case. Snap it, upload it, done.",
  },
  {
    num: "02", icon: SearchCheck, title: "MATCH & PRICE",
    text: "We match your unit to a like-for-like swap from 78+ listed systems — same power source, same style, right size. The price you see online is the price we confirm before a single tool comes out.",
  },
  {
    num: "03", icon: Truck, title: "SWAP & SHOWER",
    text: "Book a live slot online — same or next day across Perth. We swap the old unit out, connect it properly (licensed sparky included on electric), take the old one away, and you're back in a hot shower by dinner.",
  },
];

export default function Chapters() {
  return (
    <section className="bg-white border-t-4 border-tpeco-ink py-20 sm:py-28" data-testid="chapters-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <Reveal>
          <span className="chip-brutal bg-tpeco-blue border-tpeco-blue text-white">THE MANIFESTO</span>
          <h2 className="mt-4 font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.95]" data-testid="chapters-heading">
            BRRR → AHHH IN<br /><span className="bg-tpeco-pink text-white px-3 rounded-2xl inline-block">THREE MOVES</span>
          </h2>
        </Reveal>
        <div className="mt-12 space-y-0">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.num} i={i} className="grid lg:grid-cols-12 gap-6 items-center border-t-2 border-tpeco-ink py-10 group" data-testid={`chapter-${c.num}`}>
              <span className="lg:col-span-3 font-display text-[6rem] sm:text-[8rem] leading-none text-tpeco-blue group-hover:text-tpeco-pink transition-colors [-webkit-text-stroke:2px_#0A0A0A]">{c.num}</span>
              <div className="lg:col-span-3 flex items-center gap-4">
                <c.icon className="w-10 h-10 shrink-0 text-tpeco-blue" strokeWidth={2} />
                <h3 className="font-display uppercase text-3xl sm:text-4xl">{c.title}</h3>
              </div>
              <p className="lg:col-span-6 text-base sm:text-lg font-semibold text-neutral-700 max-w-2xl">{c.text}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
